import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useState } from "react";
import TemplatesIcon from "../icons/TemplatesIcon";
import "./MobileHeaderDropdown.scss";

export interface MobileTemplatesDropdownProps {
  closeDrawer: () => void;
}

export default function MobileTemplatesDropdown({closeDrawer} : MobileTemplatesDropdownProps) {
  const [isTemplatesSubmenuOpen, setTemplatesSubmenuOpen] = useState(false);

  function toggleTemplatesSubmenu() {
    setTemplatesSubmenuOpen(!isTemplatesSubmenuOpen);
  }
  
  return (
    <li>
      <a href={"/menu/browse.do"} onClick={closeDrawer}>
        <TemplatesIcon />
        Templates
      </a>
      <div className="expand-templates" onClick={toggleTemplatesSubmenu}>
        {!isTemplatesSubmenuOpen && <DownOutlined/>}
        {isTemplatesSubmenuOpen && <UpOutlined/>}
      </div>
      {isTemplatesSubmenuOpen &&
      <ul className="templates-submenu">
        <li>
          <a href={"/menu/browse.do"} onClick={closeDrawer}>
            Menus
          </a>
        </li>
        <li>
          <a href={"/category/marketing-templates.html"} onClick={closeDrawer}>
            Marketing
          </a>
        </li>
        <li>
          <a href={"/category/Digital-Menu-Boards.html"} onClick={closeDrawer}>
            Digital Menus
          </a>
        </li>
        <li>
          <a href={"/category/social-media-templates.html"} onClick={closeDrawer}>
            Social
          </a>
        </li>
        <li>
          <a href={"/category/seasonal-flyers.html"} onClick={closeDrawer}>
            Seasonal
          </a>
        </li>
      </ul>}
    </li>
  )
}